const matchingGroups = {
  Earthy: ["Chocolate", "Dairy", "Floral", "Meaty"],
  Berry: ["Spice", "Floral"],
  Citrus: [
    "Alcohol",
    "Medicinal",
    "Melon",
    "Suplhur",
    "Tree Fruit",
    "Wood",
    "Nutty",
    "Spice",
  ],
  "Dried Fruit": ["Meaty", "Phenol"],
  Melon: ["Citrus", "Fruit Like", "Green", "Suplhur", "Savoury"],
  "Tree Fruit": [
    "Citrus",
    "Dairy",
    "Floral",
    "Fruit Like",
    "Roasted",
    "Savoury",
    "Petrol",
  ],
  Tropical: ["Dairy", "Floral", "Fruit Like", "Wood", "Savoury", "Spice"],
  Roasted: ["Fruit Like", "Marine", "Petrol", "Sulphur", "Tree Fruit"],
  Phenol: ["Chocolate", "Dried Fruit", "Smoke"],
  Pungent: ["Foral", "Sour"],
  Caramel: ["Alcohol", "Fruit Like", "Savoury", "Spice", "Nutty"],
  Chocolate: [
    "Alcohol",
    "Dairy",
    "Earthy",
    "Fruit Like",
    "Nutty",
    "Phenol",
    "Meaty",
  ],
  Meaty: [
    "Alcohol",
    "Chocolate",
    "Dried Fruit",
    "Fruit Like",
    "Earthy",
    "Savoury",
    "Smoke",
  ],
  Nutty: ["Caramel", "Chocolate", "Fruit Like", "Sulphur", "Tree Fruit"],
  Toasted: ["Dairy", "Fruit Like"],
  Medicinal: ["Citrus", "Green", "Herbacious", "Sour"],
  Spice: ["Berry", "Caramel", "Citrus", "Tropical", "Wood", "Smoke"],
  Smoke: ["Meaty", "Phenol", "Sour", "Spice"],
  Petrol: ["Roasted", "Tree Fruit"],
  Wood: ["Citrus", "Herbacious", "Nutty", "Spice", "Tropical"],
  Marine: ["Roasted", "Sour", "Savoury"],
  Sour: ["Marine", "Medcinal", "Smoke", "Pungent"],
  Savoury: [
    "Alcohol",
    "Caramel",
    "Marine",
    "Melon",
    "Meaty",
    "Tree Fruit",
    "Tropical",
  ],
  "Fruit Like": [
    "Chocolate",
    "Caramel",
    "Nutty",
    "Melon",
    "Meaty",
    "Tree Fruit",
    "Toasted",
    "Roasted",
  ],
  Green: ["Medicinal", "Melon"],
  Herbacious: ["Medicinal", "Green", "Wood"],
  Alcohol: ["Chocolate", "Caramel", "Citrus", "Dairy", "Meaty", "Savoury"],
  Sulphur: ["Citrus", "Melon", "Nutty", "Roasted"],
  Dairy: [
    "Alcohol",
    "Chocolate",
    "Earthy",
    "Floral",
    "Toasted",
    "Tree Fruit",
    "Tropical",
  ],
  Floral: ["Berry", "Dairy", "Earthy", "Pungent", "Tree Fruit", "Tropical"],
};

export default matchingGroups;
